import React from 'react'
import ResourceCard from './ResourceCard'
import ResourceGroup from './ResourceGroup'
import { categoryMeta, FallbackIcon } from './constants'

export default function CategoryView({ groups, onLaunch }) {
  return (
    <div className="category-view">
      {Object.entries(groups).map(([type, items]) => {
        const meta = categoryMeta[type] || { label: type, Icon: FallbackIcon }
        const Icon = meta.Icon
        return (
          <ResourceGroup
            key={type}
            title={meta.label}
            icon={<Icon className="group-icon" />}
            count={items.length}
          >
            {items.map((item) => (
              <ResourceCard key={item.key} item={item} onLaunch={onLaunch} />
            ))}
          </ResourceGroup>
        )
      })}
    </div>
  )
}
